import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { QuestionTechnologyFormValues } from "src/models/QuestionTechnology.model";
import { useEditQuestionTechnologyMutation, useGetQuestionTechnologyByIdQuery } from "src/services/QuestionTechnologyServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import JobForm from "../Layout/QuestionTechnologyForm";

type Props = {
  onClose: () => void;
  technologyId: string;
};

const EditQuestionTechnologyFormWrapper = ({ onClose, technologyId }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);
  const [questionTechnologyData, setQuestionTechnology] = useState<any>({});

  const [editQuestionTechnology] = useEditQuestionTechnologyMutation();
  const { data, isLoading, isFetching } = useGetQuestionTechnologyByIdQuery({
    id: technologyId,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setQuestionTechnology(data?.data);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: QuestionTechnologyFormValues = {
    category: questionTechnologyData?.questionTechnology || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    category: string().required("Please enter technology"),
  });

  // Handle Submit
  const handleSubmit = (
    values: QuestionTechnologyFormValues,
    { setSubmitting, resetForm }: FormikHelpers<QuestionTechnologyFormValues>
  ) => {
    const formatedValue = {
      questionTechnology: values.category,
    };
    editQuestionTechnology({
      body: formatedValue,
      id: technologyId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <JobForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Edit"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditQuestionTechnologyFormWrapper;
